module.exports = __webpack_public_path__ + "img/ticVerde.eb304eb2.png";